import { render, staticRenderFns } from "./NotesSubfolder.vue?vue&type=template&id=58d36d17&scoped=true&"
import script from "./NotesSubfolder.vue?vue&type=script&lang=js&"
export * from "./NotesSubfolder.vue?vue&type=script&lang=js&"
import style0 from "./NotesSubfolder.vue?vue&type=style&index=0&id=58d36d17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d36d17",
  null
  
)

export default component.exports